import React, { useState } from "react";
import "./demo.css";
import { axiosInstance } from "../axiosInstance";
import { baseUrl } from "../environment";
import BackButton from "../Shared/CommonComponent/BackButton";
import emailjs from "@emailjs/browser";

function Demo() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyName: "",
    industry: "",
    roleIds: ["833f087b-7b4a-4696-8ead-40ce42a3adbf"],
  });

  const [formStatus, setFormStatus] = useState(""); // For submission feedback

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Add your submission logic here (e.g., API call)
    console.log(formData);
    axiosInstance
      .post(baseUrl + "Auth/Signup", formData)
      .then((res) => {
        if (res) {
          setFormStatus(
            "Thank you for requesting a demo! We'll contact you soon."
          );

          const formDataForEmailJsProxy = {
            name: formData.name,
            email: formData.email,
            company_name: formData.companyName,
            industry: formData.industry
          };

          setFormData({
            name: "",
            email: "",
            companyName: "",
            industry: "",
            roleIds: ["833f087b-7b4a-4696-8ead-40ce42a3adbf"],
          });
          setTimeout(() => {
            setFormStatus("");
          }, 2000);

          emailjs
            .send(
              "service_gc8bdh9", // Replace with your EmailJS Service ID
              "template_loydewr", // Replace with your EmailJS Template ID
              formDataForEmailJsProxy,
              "wdmxVmWg5ZnAuyatY" // Replace with your EmailJS Public Key
            )
            .then(
              (response) => {
                // console.log("Email sent successfully!", response.status, response.text);
                // alert("Email Sent Successfully!");
              },
              (error) => {
                console.error("Email sending failed:", error);
                alert("Failed to send email.");
              }
            );
        }
      })
      .catch((err) => {
        setFormStatus(
          "Something Went Wrong with the network. Please Try Again Later."
        );
        setTimeout(() => {
          setFormStatus("");
        }, 2000);
      });

    // Simulate successful submission
  };

  return (
    <>
      <BackButton />
      <div className="demo-request-form">
        <h2>Experience Contract Assist in action</h2>
        <p>Schedule a live product demonstration today.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="Enter your company name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="industry">Industry</label>
            <input
              type="text"
              id="industry"
              name="industry"
              value={formData.industry}
              onChange={handleChange}
              placeholder="Enter your industry"
              required
            />
          </div>

          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>

        {formStatus && <p className="form-status">{formStatus}</p>}
      </div>
    </>
  );
}

export default Demo;
